import { toastr } from 'react-redux-toastr';
import { I18n } from 'src/translations/i18n';
import Utils from 'src/utils';

import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_SLIP_TIMES_LIST_REQUEST = 'LOAD_SLIP_TIMES_LIST_REQUEST';
export const LOAD_SLIP_TIMES_LIST_SUCCESS = 'LOAD_SLIP_TIMES_LIST_SUCCESS';
export const LOAD_SLIP_TIMES_LIST_FAIL = 'LOAD_SLIP_TIMES_LIST_FAIL';

export const CREATE_SLIP_TIME_REQUEST = 'CREATE_SLIP_TIME_REQUEST';
export const CREATE_SLIP_TIME_SUCCESS = 'CREATE_SLIP_TIME_SUCCESS';
export const CREATE_SLIP_TIME_FAIL = 'CREATE_SLIP_TIME_FAIL';

export const UPDATE_SLIP_TIME_REQUEST = 'UPDATE_SLIP_TIME_REQUEST';
export const UPDATE_SLIP_TIME_SUCCESS = 'UPDATE_SLIP_TIME_SUCCESS';
export const UPDATE_SLIP_TIME_FAIL = 'UPDATE_SLIP_TIME_FAIL';

export const DELETE_SLIP_TIME_REQUEST = 'DELETE_SLIP_TIME_REQUEST';
export const DELETE_SLIP_TIME_SUCCESS = 'DELETE_SLIP_TIME_SUCCESS';
export const DELETE_SLIP_TIME_FAIL = 'DELETE_SLIP_TIME_FAIL';

export const LOAD_SLIP_TIMES_ASSOCIATIONS_LIST_REQUEST = 'LOAD_SLIP_TIMES_ASSOCIATIONS_LIST_REQUEST';
export const LOAD_SLIP_TIMES_ASSOCIATIONS_LIST_SUCCESS = 'LOAD_SLIP_TIMES_ASSOCIATIONS_LIST_SUCCESS';
export const LOAD_SLIP_TIMES_ASSOCIATIONS_LIST_FAIL = 'LOAD_SLIP_TIMES_ASSOCIATIONS_LIST_FAIL';

export const CREATE_SLIP_TIME_ASSOCIATIONS_REQUEST = 'CREATE_SLIP_TIME_ASSOCIATIONS_REQUEST';
export const CREATE_SLIP_TIME_ASSOCIATIONS_SUCCESS = 'CREATE_SLIP_TIME_ASSOCIATIONS_SUCCESS';
export const CREATE_SLIP_TIME_ASSOCIATIONS_FAIL = 'CREATE_SLIP_TIME_ASSOCIATIONS_FAIL';

export const DELETE_SLIP_TIME_ASSOCIATIONS_REQUEST = 'DELETE_SLIP_TIME_ASSOCIATIONS_REQUEST';
export const DELETE_SLIP_TIME_ASSOCIATIONS_SUCCESS = 'DELETE_SLIP_TIME_ASSOCIATIONS_SUCCESS';
export const DELETE_SLIP_TIME_ASSOCIATIONS_FAIL = 'DELETE_SLIP_TIME_ASSOCIATIONS_FAIL';

const loadSlipTimesListRequest = () => (dispatch) => dispatch({ type: LOAD_SLIP_TIMES_LIST_REQUEST });
const loadSlipTimesListSuccess = (list) => (dispatch) => dispatch({ type: LOAD_SLIP_TIMES_LIST_SUCCESS, list });
const loadSlipTimesListFail = () => (dispatch) => dispatch({ type: LOAD_SLIP_TIMES_LIST_FAIL });

const createSlipTimeRequest = () => (dispatch) => dispatch({ type: CREATE_SLIP_TIME_REQUEST });
const createSlipTimeSuccess = () => (dispatch) => dispatch({ type: CREATE_SLIP_TIME_SUCCESS });
const createSlipTimeFail = () => (dispatch) => dispatch({ type: CREATE_SLIP_TIME_FAIL });

const updateSlipTimeRequest = () => (dispatch) => dispatch({ type: UPDATE_SLIP_TIME_REQUEST });
const updateSlipTimeSuccess = () => (dispatch) => dispatch({ type: UPDATE_SLIP_TIME_SUCCESS });
const updateSlipTimeFail = () => (dispatch) => dispatch({ type: UPDATE_SLIP_TIME_FAIL });

const deleteSlipTimeRequest = () => (dispatch) => dispatch({ type: DELETE_SLIP_TIME_REQUEST });
const deleteSlipTimeSuccess = () => (dispatch) => dispatch({ type: DELETE_SLIP_TIME_SUCCESS });
const deleteSlipTimeFail = () => (dispatch) => dispatch({ type: DELETE_SLIP_TIME_FAIL });

const loadSlipTimesAssociationsListRequest = () => (dispatch) => dispatch({ type: LOAD_SLIP_TIMES_ASSOCIATIONS_LIST_REQUEST });
// eslint-disable-next-line max-len
const loadSlipTimesAssociationsListSuccess = (associations) => (dispatch) => dispatch({ type: LOAD_SLIP_TIMES_ASSOCIATIONS_LIST_SUCCESS, associations });
const loadSlipTimesAssociationsListFail = () => (dispatch) => dispatch({ type: LOAD_SLIP_TIMES_ASSOCIATIONS_LIST_FAIL });

const createSlipTimeAssociationsRequest = () => (dispatch) => dispatch({ type: CREATE_SLIP_TIME_ASSOCIATIONS_REQUEST });
const createSlipTimeAssociationsSuccess = () => (dispatch) => dispatch({ type: CREATE_SLIP_TIME_ASSOCIATIONS_SUCCESS });
const createSlipTimeAssociationsFail = () => (dispatch) => dispatch({ type: CREATE_SLIP_TIME_ASSOCIATIONS_FAIL });

const deleteSlipTimeAssociationsRequest = () => (dispatch) => dispatch({ type: DELETE_SLIP_TIME_ASSOCIATIONS_REQUEST });
const deleteSlipTimeAssociationsSuccess = () => (dispatch) => dispatch({ type: DELETE_SLIP_TIME_ASSOCIATIONS_SUCCESS });
const deleteSlipTimeAssociationsFail = () => (dispatch) => dispatch({ type: DELETE_SLIP_TIME_ASSOCIATIONS_FAIL });

export const loadSlipTimesList = () => (dispatch) => {
  dispatch(loadSlipTimesListRequest());
  return new Promise((resolve, reject) => {
    communicate({ url: 'SlipTimes' }).then(({ data }) => {
      dispatch(loadSlipTimesListSuccess(data.Data.reverse()));
      resolve();
    }).catch((e) => {
      toastrError(e);
      dispatch(loadSlipTimesListFail(e));
      reject();
    });
  });
};

export const createSlipTime = (data) => (dispatch) => {
  dispatch(createSlipTimeRequest());
  return new Promise((resolve, reject) => {
    communicate({ url: 'SlipTimes', method: 'post', data }).then((response) => {
      toastrSuccess(response);
      dispatch(createSlipTimeSuccess());
      dispatch(loadSlipTimesList())
        .then(() => resolve(response.data.Data));
    }).catch((e) => {
      toastrError(e);
      dispatch(createSlipTimeFail(e));
      reject(e);
    });
  });
};

export const updateSlipTime = (data) => (dispatch) => {
  dispatch(updateSlipTimeRequest());
  return new Promise((resolve) => {
    communicate({ url: 'SlipTimes', method: 'put', data }).then((response) => {
      toastrSuccess(response);
      dispatch(updateSlipTimeSuccess(response.data.Data));
      dispatch(loadSlipTimesList())
        .then(() => resolve(response.data.Data));
    }).catch((e) => {
      toastrError(e);
      dispatch(updateSlipTimeFail(e));
    });
  });
};

export const deleteSlipTime = (id) => (dispatch) => {
  dispatch(deleteSlipTimeRequest());
  return communicate({ url: 'SlipTimes', method: 'delete', getParams: Utils.objects.getQueryStringFromObject({ id }) }).then((response) => {
    toastrSuccess(response);
    dispatch(deleteSlipTimeSuccess(response.data));
    dispatch(loadSlipTimesList());
  }).catch((e) => {
    if (e.response?.data?.ResultId === 365) { // Value is in use by an association
      toastr.error(I18n.t('DeleteWorkShiftAssociations'));
    } else {
      toastrError(e);
    }
    dispatch(deleteSlipTimeFail(e));
  });
};

export const loadSlipTimesAssociationsList = () => (dispatch) => {
  dispatch(loadSlipTimesAssociationsListRequest());
  return communicate({ url: 'SlipTimeAssociations' }).then(({ data }) => {
    dispatch(loadSlipTimesAssociationsListSuccess(data.Data));
  }).catch((e) => {
    toastrError(e);
    dispatch(loadSlipTimesAssociationsListFail(e));
  });
};

export const createSlipTimeAssociations = (data) => (dispatch) => {
  dispatch(createSlipTimeAssociationsRequest());
  return communicate({ url: 'SlipTimeAssociations', method: 'post', data }).then((response) => {
    toastrSuccess(response);
    dispatch(createSlipTimeAssociationsSuccess(response.data));
    dispatch(loadSlipTimesAssociationsList());
  }).catch((e) => {
    toastrError(e);
    dispatch(createSlipTimeAssociationsFail(e));
  });
};

export const deleteSlipTimeAssociations = (id) => (dispatch) => {
  dispatch(deleteSlipTimeAssociationsRequest());
  return communicate({
    url: 'SlipTimeAssociations',
    method: 'delete',
    getParams: Utils.objects.getQueryStringFromObject({ id })
  }).then((response) => {
    toastrSuccess(response);
    dispatch(deleteSlipTimeAssociationsSuccess(response.data));
    dispatch(loadSlipTimesAssociationsList());
  }).catch((e) => {
    toastrError(e);
    dispatch(deleteSlipTimeAssociationsFail(e));
  });
};
